import {
  BuyOrderType,
  SellOrderType,
  Expiry,
  SplitOrderMethodEnum,
} from 'global/Securities/types/transaction';
import create from 'zustand';

import { LEVERAGE } from 'global/TradingModal/RealTradingModal/types';
import { triggerPriceOption } from '../constant';

interface iRealTradingState {
  configType: number;
  expiry: Expiry;
  price: number;
  shares: number;
  stockCode: string | null;
  triggerPrice: number | null;
  type: BuyOrderType | SellOrderType;
  typeDescription: string;
  availableLot: number;
  isSplitOrderActive: boolean;
  splitQuantity: number;
  splitRangeMin: number;
  splitRangeMax: number;
  sellLeverage: LEVERAGE;
  dayTradeActive: boolean;
  dayTradeMultiplier: number;
  splitMethod: SplitOrderMethodEnum;
}

interface iRealTradingStore extends iRealTradingState {
  setConfigType: (any) => void;
  setExpiry: (expiry: Expiry) => void;
  setOrderType: (orderType: BuyOrderType | SellOrderType) => void;
  setPrice: (any) => void;
  setShares: (any) => void;
  setStockCode: (any) => void;
  setTriggerPrice: (any) => void;
  resetOrderData: () => void;
  setAvailableLot: (any) => void;
  setTradingData: (any) => void;
  setSplitOrderActive: (isSplitOrderActive: boolean) => void;
  setSplitQuantity: (splitQuantity: number) => void;
  setSplitRange: (splitRangeMin: number, splitRangeMax: number) => void;
  setSellLeverage: (sellLeverage: LEVERAGE) => void;
  setDayTradeActive: (active: boolean) => void;
  setDayTadeMultiplier: (multiplier: number) => void;
  setSplitMethod: (splitMethod: SplitOrderMethodEnum) => void;
}

const initialState: iRealTradingState = {
  configType: 2,
  expiry: Expiry.GoodForDay,
  price: 0,
  shares: 0,
  stockCode: '',
  triggerPrice: 0,
  availableLot: 0,
  type: BuyOrderType.LimitOrder,
  typeDescription: 'Limit Order',
  isSplitOrderActive: false,
  splitQuantity: null,
  splitRangeMin: null,
  splitRangeMax: null,
  splitMethod: SplitOrderMethodEnum.RANDOM,
  sellLeverage: null,
  dayTradeActive: false,
  dayTradeMultiplier: 0,
};

const realTradingStore = create<iRealTradingStore>((set) => ({
  ...initialState,

  setConfigType: (payload) => {
    const index = triggerPriceOption.indexOf(payload);
    set({ configType: index + 1 });
  },
  setExpiry: (expiry) => {
    set({ expiry });
  },
  setOrderType: (type) => {
    set({ type });
  },
  setPrice: (payload) => {
    const value = Number(payload);
    set({ price: value });
  },
  setAvailableLot: (payload) => {
    const value = Number(payload);
    set({ availableLot: value });
  },
  setShares: (payload) => {
    const value = Number(payload);
    set({ shares: value });
  },
  setStockCode: (payload) => {
    set({ stockCode: payload });
  },
  setTriggerPrice: (payload) => {
    const value = Number(payload);
    set({ triggerPrice: value });
  },
  resetOrderData: () => {
    set(initialState);
  },
  setTradingData: (payload) => {
    set({ ...payload });
  },
  setSplitOrderActive: (isSplitOrderActive) => {
    set({ isSplitOrderActive });
  },
  setSplitQuantity: (splitQuantity) => {
    set({ splitQuantity });
  },
  setSplitRange: (splitRangeMin, splitRangeMax) => {
    set({ splitRangeMin, splitRangeMax });
  },
  setSellLeverage: (sellLeverage) => {
    set({ sellLeverage });
  },
  setDayTradeActive: (active) => {
    set({ dayTradeActive: active });
  },
  setDayTadeMultiplier: (multiplier) => {
    set({ dayTradeMultiplier: multiplier });
  },
  setSplitMethod(splitMethod) {
    set({ splitMethod });
  },
}));

export default realTradingStore;
